'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/distinctUntilChanged';
const angular = require('angular');
const {noop} = angular;

var textShortEditTemplate = require('./field-templates/text-short/response-edit.html');
var textLongEditTemplate = require('./field-templates/text-long/response-edit.html');
var dateEditTemplate = require('./field-templates/date/response-edit.html');
var durationEditTemplate = require('./field-templates/duration/response-edit.html');
var scaleEditTemplate = require('./field-templates/scale/response-edit.html');
var listEditTemplate = require('./field-templates/list/response-edit.html');
var locationEditTemplate = require('./field-templates/location/response-edit.html');
var fileEditTemplate = require('./field-templates/file/response-edit.html');
var referenceLinkEditTemplate = require('./field-templates/reference-link/response-edit.html');

var textShortViewTemplate = require('./field-templates/text-short/response-view.html');
var textLongViewTemplate = require('./field-templates/text-long/response-view.html');
var dateViewTemplate = require('./field-templates/date/response-view.html');
var durationViewTemplate = require('./field-templates/duration/response-view.html');
var scaleViewTemplate = require('./field-templates/scale/response-view.html');
var listViewTemplate = require('./field-templates/list/response-view.html');
var locationViewTemplate = require('./field-templates/location/response-view.html');
var fileViewTemplate = require('./field-templates/file/response-view.html');
var referenceLinkViewTemplate = require('./field-templates/reference-link/response-view.html');

module.exports.directive = [
  'TransformerDirectiveFactory',
  FormFieldResponseDirective];

module.exports.controller = [
  '$scope',
  'TransformerMixin',
  FormFieldResponseController];

module.exports.templates = [
  '$templateCache',
  CacheTemplates];

function CacheTemplates($templateCache) {
  $templateCache.put('forms/text-short/response-edit.html', textShortEditTemplate);
  $templateCache.put('forms/text-long/response-edit.html', textLongEditTemplate);
  $templateCache.put('forms/date/response-edit.html', dateEditTemplate);
  $templateCache.put('forms/duration/response-edit.html', durationEditTemplate);
  $templateCache.put('forms/scale/response-edit.html', scaleEditTemplate);
  $templateCache.put('forms/list/response-edit.html', listEditTemplate);
  $templateCache.put('forms/location/response-edit.html', locationEditTemplate);
  $templateCache.put('forms/file/response-edit.html', fileEditTemplate);
  $templateCache.put('forms/reference-link/response-edit.html', referenceLinkEditTemplate);

  $templateCache.put('forms/text-short/response-view.html', textShortViewTemplate);
  $templateCache.put('forms/text-long/response-view.html', textLongViewTemplate);
  $templateCache.put('forms/date/response-view.html', dateViewTemplate);
  $templateCache.put('forms/duration/response-view.html', durationViewTemplate);
  $templateCache.put('forms/scale/response-view.html', scaleViewTemplate);
  $templateCache.put('forms/list/response-view.html', listViewTemplate);
  $templateCache.put('forms/location/response-view.html', locationViewTemplate);
  $templateCache.put('forms/file/response-view.html', fileViewTemplate);
  $templateCache.put('forms/reference-link/response-view.html', referenceLinkViewTemplate);
}

// model is a MergedField

function FormFieldResponseDirective(
  TransformerDirectiveFactory,
) {
  var transformConfig = {
    bindToController: true,
    controllerAs: 'formFieldResponse',
    modes: [
      {name: 'response-edit-text_short', templateUrl: 'forms/text-short/response-edit.html'},
      {name: 'response-view-text_short', templateUrl: 'forms/text-short/response-view.html', defaultMode: true},

      {name: 'response-edit-text_long', templateUrl: 'forms/text-long/response-edit.html'},
      {name: 'response-view-text_long', templateUrl: 'forms/text-long/response-view.html'},

      {name: 'response-edit-date', templateUrl: 'forms/date/response-edit.html'},
      {name: 'response-view-date', templateUrl: 'forms/date/response-view.html'},

      {name: 'response-edit-duration', templateUrl: 'forms/duration/response-edit.html'},
      {name: 'response-view-duration', templateUrl: 'forms/duration/response-view.html'},

      {name: 'response-edit-scale', templateUrl: 'forms/scale/response-edit.html'},
      {name: 'response-view-scale', templateUrl: 'forms/scale/response-view.html'},

      {name: 'response-edit-list', templateUrl: 'forms/list/response-edit.html'},
      {name: 'response-view-list', templateUrl: 'forms/list/response-view.html'},

      {name: 'response-edit-location', templateUrl: 'forms/location/response-edit.html'},
      {name: 'response-view-location', templateUrl: 'forms/location/response-view.html'},

      {name: 'response-edit-file', templateUrl: 'forms/file/response-edit.html'},
      {name: 'response-view-file', templateUrl: 'forms/file/response-view.html'},

      {name: 'response-edit-reference_link', templateUrl: 'forms/reference-link/response-edit.html'},
      {name: 'response-view-reference_link', templateUrl: 'forms/reference-link/response-view.html'}
    ]
  };

  return {
    restrict: 'E',
    template: '',
    scope: {
      currentMode: '=?',
      api: '=?fieldApi',
      model: '='
    },
    bindToController: true,
    controllerAs: 'formFieldResponse',
    controller: 'FormFieldResponseController',
    compile: TransformerDirectiveFactory(transformConfig)
  }
}

function FormFieldResponseController(
  $scope,
  TransformerMixin,
) {
  var vm = this;
  vm.api = vm.api || {};

  var transformer = TransformerMixin($scope, vm);

  // Define API
  Object.defineProperties(vm.api, {
    getMode: {enumerable: true, configurable: true, value: getModeType},
    setMode: {enumerable: true, configurable: true, value: setModeType}
  });

  $scope.$on('$destroy', cleanup);

  function cleanup() {
    modeSubscription && modeSubscription.unsubscribe();
  }


  /*****************************************************************************************************************
   * Watch mode
   ****************************************************************************************************************/

  function returnNewValue(value) {
    return value && value.newValue;
  }

  // observe the model type
  var fieldTypeObservable = $scope.$toObservable(function () {
    return vm.model && vm.model.field && vm.model.field.type;
  }).map(returnNewValue);

  // observe the current mode
  var modeObservable = $scope.$toObservable(function () {
    return vm.currentMode;
  }).map(returnNewValue);

  var modeTypeObservable = modeObservable
    .map(function (mode) {
      return mode && mode.substring(0, 13)
    })
    .distinctUntilChanged();

  // on type change, change the transformer mode, respecting edit/view mode type
  var modeSubscription = Observable.combineLatest(
    fieldTypeObservable,
    modeTypeObservable,
    function (type, modeType) {
      return [type, modeType]
    }
    )
    .distinctUntilChanged()
    .subscribe($scope.$bindSafeApply(function (data) {
      // kind of a hack
      vm.required = vm.model.field.options.required;

      // even though we're ignoring data[0] here, we need to trigger an update if it has changed.
      setModeType(data[1]);
    }));

  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function getModeType() {
    return vm.currentMode.indexOf('edit') > -1 ? 'response-edit' : 'response-view';
  }

  function setModeType(mode) {
    updateDisplayMode(vm.model.field.type, mode);
    updateTypePresentation(vm.model.field.type);
    vm.showPlaceholder = getShowPlaceholder(vm.model.field.type);
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  function updateDisplayMode(fieldType, modeType) {
    transformer.changeMode([modeType, fieldType].join('-'));
  }

  function updateTypePresentation(fieldType) {
    switch (fieldType) {
      case 'scale':
        initRangeLabel();
        break;
      case 'list':
        initList();
        break;
    }
  }

  function getShowPlaceholder(type) {
    switch (type) {
      case 'text_short':
        if (vm.model.field.options.isNumber)
          return numberPlaceholder;
      /* fall-through */
      case 'text_long':
      case 'date':
        return textPlaceholder;
      case 'list':
        return listPlaceholder;
      default:
        return noop;
    }
  }

  function numberPlaceholder() {
    return !vm.model.response.result.value && vm.model.response.result.value !== 0;
  }

  function textPlaceholder() {
    return !vm.model.response.result.value;
  }

  function listPlaceholder() {
    return !vm.listDisplay;
  }


  /*****************************************************************************************************************
   * DateTime specific
   ****************************************************************************************************************/

  vm.getDateTimeFormat = getDateTimeFormat;

  //TODO(i18n): need to choose format based on selected Locale
  function getDateTimeFormat() {
    if (vm.model.field.options.includeDate && vm.model.field.options.includeTime) {
      return 'MMM d, y \'at\' h:mm a';
    } else {
      return vm.model.field.options.includeDate ? 'mediumDate' : 'h:mm a';
    }
  }


  /*****************************************************************************************************************
   * Range specific
   ****************************************************************************************************************/

  // Update the label
  function initRangeLabel() {
    vm.rangeOptions = {
      floor: vm.model.field.options.startNumber,
      ceil: vm.model.field.options.endNumber,
      step: vm.model.field.options.step,
      disabled: vm.currentMode.indexOf('edit') === -1
    };
  }


  /*****************************************************************************************************************
   * List specific
   ****************************************************************************************************************/

  vm.updateList = updateList;

  function initList() {
    var i;
    vm.listItems = {};

    if (vm.model.response.result && vm.model.field.options.selectMany) {
      watchResultsListArray();
      i = vm.model.response.result.length;
      while (i--) {
        vm.listItems[vm.model.response.result[i].id] = true;
      }
    } else {
      watchResultsListSingle();
    }
  }

  // used only in select many mode
  function updateList() {
    updateResults();
  }

  function updateResults() {
    vm.model.response.result = [];
    for (var i = 0, length = vm.model.field.options.items.length; i < length; i++) {
      if (vm.listItems[vm.model.field.options.items[i].id]) {
        vm.model.response.result.push(vm.model.field.options.items[i]);
      }
    }
    // updateListDisplay();
  }

  function watchResultsListSingle() {
    $scope.$watch(function () {
      return vm.model && vm.model.response.result && vm.model.response.result.label;
    }, function (value) {
      if (value) {
        vm.listDisplay = value;
      } else {
        vm.listDisplay = '';
      }
    });
  }

  function watchResultsListArray() {
    $scope.$watch(function () {
      return vm.model && vm.model.response.result && vm.model.response.result.length;
    }, function () {
      updateListDisplay();
    });
  }

  function updateListDisplay() {
    var result = [];
    for (var i = 0, length = vm.model.response.result.length; i < length; i++) {
      if (vm.model.response.result[i] && vm.model.response.result[i].label)
        result.push(vm.model.response.result[i].label);
    }
    vm.listDisplay = result.length ? result.join(', ') : '';
  }
}


// WEBPACK FOOTER //
// ./src/js/forms/directives/FormFieldResponseDirective.js